import type { ReviewPhotoGalleryProps } from "../../types/components/reviewPhotoGallery";
import type { ImageGalleryProps } from "../../types/components/imageGallery";

export const mapPhotoGalleryProps = ({
  isOpen,
  reviewPhotoList,
  atIndex,
}: ReviewPhotoGalleryProps): ImageGalleryProps => ({
  isOpen,
  atIndex,
  imageList: reviewPhotoList.map(({ fullSizeUrl }) => ({
    url: fullSizeUrl,
  })),
});
